import { OSType } from '@/types';

export enum DownloadStatusEnum {
  IDLE = 1,
  IN_PROGRESS,
  DONE,
  MAY_TAKE_TIME,
}

export type DownloadButtonStateProps = {
  type: 'dataPreparer' | 'uploadModal' | 'cdfiReport' | 'cdfiCertification';
  os?: OSType;
  onSuccess?: () => void;
  preQualReportParams?: string;
};
